module.exports = __webpack_public_path__ + "static/media/light_medium.08966b6f.jpg";